export default "__VITE_ASSET__BwsdgzlT__"